// import { ulid } from 'ulid';

import { Decimal } from 'decimal.js';

import { WsDecodeBoardInterface, WsDecodeData, WsDecodeMetric, WsDecodeSource } from '../../../../../core/src/interfaces';

import { WsDecodeMeasurement, WsDecodeScoreView } from '../../../enums';

import { isNumeric } from '../../../helpers';
import { getAdjustmentFactor } from '../../../decode-filters';








const metricString = `SERVICE|MICROSOFT_GRAPH|Technology Adoption|01JB9501AR3JC5A95EBPJTXKBF
SERVICE|MICROSOFT_GRAPH|Technology Experience|01JB950BS4F4Z1TK3SCG4YX8JB
SERVICE|MICROSOFT_GRAPH|Secure Score|01JB950RXXHDCYHVF4WZ8H0CBS
USER   |NEXTHINK|DexScoreValue|01JB9844835Y82NDABGCJNZKMS
USER   |NEXTHINK|CollaborationValue|01JB9844Q8H4G9G8S0H9W3HRK4
USER   |SURVEIL|MethodsRegistered|01JB9FWCBVGM82WA4S1V7YSP6Q
USER   |SURVEIL|External|01JB9FWCHJP3W8JCXX07DG944E
USER   |SURVEIL|IsMFACapable|01JB9FWCPS86GSRXF5Y3GEFT73
USER   |SURVEIL|IsMFARegistered|01JB9FWCWKNNBFCX94PR353ETE
USER   |SURVEIL|IsPasswordlessCapable|01JB9FWD1P7QDZNFG6G843EN3T
USER   |SURVEIL|IsSSPRCapable|01JB9FWD7ETCBSQJE5E7VGGKXA
USER   |SURVEIL|IsSSPREnabled|01JB9FWDC4KVEAPM1B0SQW1GXC
USER   |SURVEIL|IsSSPRRegistered|01JB9FWDHVPDB3K54KK0GYC23N
USER   |MICROSOFT_GRAPH|IsDeleted|01JB9FWDQKV0V8PX0J3E0BXPD0
USER   |MICROSOFT_GRAPH|HasExchangeLicense|01JB9FWDXA22NFSYC68EEBMT6Q
USER   |MICROSOFT_GRAPH|HasOneDriveLicense|01JB9FWE3JV9HNBWEMM2MJ7013
USER   |MICROSOFT_GRAPH|HasSharePointLicense|01JB9FWEA8PJQRVAN6MTDH3195
USER   |MICROSOFT_GRAPH|HasSkypeForBusinessLicense|01JB9FWEE0DJ743CC9X4BV79B2
USER   |MICROSOFT_GRAPH|HasYammerLicense|01JB9FWEK6JWWZ2QS8DCV400JT
USER   |MICROSOFT_GRAPH|HasTeamsLicense|01JB9FWERCGB7269HCMCJBR4EP
USER   |MICROSOFT_GRAPH|ExchangeLastActivityDate|01JB9FWEY4P0SWPZZ7NTYC0PQM
USER   |MICROSOFT_GRAPH|OneDriveLastActivityDate|01JB9FWF3B683GKF318SB5J35V
USER   |MICROSOFT_GRAPH|SharePointLastActivityDate|01JB9FWF9KJHRYFCHR8VDQGP0Z
USER   |MICROSOFT_GRAPH|SkypeForBusinessLastActivityDate|01JB9FWFFAPXX5VX8KR6Q0RGHE
USER   |MICROSOFT_GRAPH|YammerLastActivityDate|01JB9FWFN1H3PJ14MBXAMKYSPM
USER   |MICROSOFT_GRAPH|TeamsLastActivityDate|01JB9FWFSQDX5JMSQBC2W3FQTB
USER   |MICROSOFT_GRAPH|ExchangeLicenseAssignDate|01JB9FWG3M74V0V8K32BVVRQK7
USER   |MICROSOFT_GRAPH|OneDriveLicenseAssignDate|01JB9FWG8TN05J7B8MNFCZ9D8V
USER   |MICROSOFT_GRAPH|SharePointLicenseAssignDate|01JB9FZXXNT9FN8Q4MQ7K2BCA0
USER   |MICROSOFT_GRAPH|SkypeForBusinessLicenseAssignDate|01JB9FZYA63QV7KQ3ED52HG4A0
USER   |MICROSOFT_GRAPH|YammerLicenseAssignDate|01JB9FZYM63TDVPBD27EJ5VFQC
USER   |MICROSOFT_GRAPH|TeamsLicenseAssignDate|01JB9FZYVBYWHR7M24MK15W99T
DEVICE|NEXTHINK|AvgDeviceReadyTime|01JB9845C1RBQW49JRQ65868DF
DEVICE|NEXTHINK|AvgWifiTransRate  |01JB98460VPECTK46A7EYRAX3F
DEVICE|NEXTHINK|AvgBootTime7d     |01JB98469QNSM986R6M3BP8DX4
DEVICE|NEXTHINK|AvgWifiStrength   |01JB9846GGNFVKR23SHEYXQ622
DEVICE|NEXTHINK|NumBoots7d        |01JB9847EPKVJ4AX8Y3METPAZY
DEVICE|NEXTHINK|InstalledMemory   |01JB984ABX3S73E8ZQEXA5SQBH
DEVICE|NEXTHINK|FreeMemory        |01JB984APA2PJ069Q40H9YMBW2
DEVICE|NEXTHINK|NumErrors         |01JB984AZQAG0E95EB2M5MFTWZ
DEVICE|NEXTHINK|NumAlerts         |01JB9861CW260XQR5Y2ZEAMVEY
DEVICE|NEXTHINK|NumHardResets     |01JB9861PRJH7D5RY91CV0FSDK
DEVICE|NEXTHINK|NumSystemCrashes7d|01JB9861ZMXXNZJWVASYMMCR2F
DEVICE|NEXTHINK|NumAppCrashes7d   |01JB98628F87XPA71BCDC3R2CZ
DEVICE|LOG_ANALYTICS|OSName|01JB9A8WQYNDP8WV8X9D2HZM7N
DEVICE|LOG_ANALYTICS|OSVersion|01JB9A8X2CZSV1JN8148PQM7H3
DEVICE|LOG_ANALYTICS|OSBuild|01JB9A8XCR1DH7RHQAN4QNPF92
DEVICE|LOG_ANALYTICS|ReadinessStatus|01JB9A8XPPDKTZK2G7ZYC6JQXT
DEVICE|LOG_ANALYTICS|ReadinessReason|01JB9A8Y352RM641611Y0JSEMB
DEVICE|LOG_ANALYTICS|ReadinessScanTime|01JB9A8YE3K611YR5W5FKBH6VS
DEVICE|LOG_ANALYTICS|ReadinessExpiryTime|01JB9A8YT2S2621ZBYNTCXYC1Y
DEVICE|LOG_ANALYTICS|SetupReadinessStatus|01JB9A8Z50N37D4NX9T0KSS5DC
DEVICE|LOG_ANALYTICS|SetupReadinessReason|01JB9A8ZFYW7XT5WSTXKA68A08
DEVICE|LOG_ANALYTICS|SetupReadinessTime|01JB9A8ZSTFN0Q257KRCYHH33S
DEVICE|LOG_ANALYTICS|SetupReadinessExpiryTime|01JB9A907Y8P4ZVWZGBAQ2RMH4
APPLICATION|INTUNE|publisher|01JB9A3J2Z2TRHHY63DEP2Z1QE
APPLICATION|INTUNE|appTypeKey|01JB9A3JMNE2QT8DFP7HPCC5QV
APPLICATION|INTUNE|vppProgramTypeKey|01JB9A3JXH04PPYM0YV4V4KTZ9
APPLICATION|INTUNE|size|01JB9A3K5CJ2SBA9ZNH8P5D1X8
APPLICATION|INTUNE|isCurrent|01JB9A3KFS7CW3TJXKCTD86B3J
APPLICATION|INTUNE|isDeleted|01JB9A3KRNM61YWJMQW1PXW34E
APPLICATION|INTUNE|startDateInclusiveUTC|01JB9A3M208K178SA623SB1YZB
APPLICATION|INTUNE|endDateExclusiveUTC|01JB9A3MAV7E2MYKPZHSYEKB83
APPLICATION|INTUNE|appInstallStateKey|01JB9A3MQBFDQDETGEHX12RF4G`;




const createMetric = async () => {
};

const updateMetric = async () => {
};











const labelString = `conformed.factchangerequests,ServiceNow,CreatedByUser,string,User
conformed.factchangerequests,ServiceNow,ChangeNumber,string,User
conformed.factchangerequests,ServiceNow,SysUpdatedOn,timestamp,User
conformed.factchangerequests,ServiceNow,DeliveryPlan,string,User
conformed.factchangerequests,ServiceNow,ShortDescription,string,User
conformed.factchangerequests,ServiceNow,DeliveryTask,string,User
conformed.factchangerequests,ServiceNow,ChangePlan,string,User
conformed.factchangerequests,ServiceNow,BusinessService,string,User
conformed.factchangerequests,ServiceNow,Description,string,User
conformed.factchangerequests,ServiceNow,TimeWorked,interval,User
conformed.factchangerequests,ServiceNow,MadeSLA,boolean,User
conformed.factchangerequests,ServiceNow,CloseNotes,string,User
conformed.factchangerequests,ServiceNow,WatchList,string,User
conformed.factchangerequests,ServiceNow,BackoutPlan,string,User
conformed.factchangerequests,ServiceNow,Comments,string,User
conformed.factchangerequests,ServiceNow,RequestedByDate,timestamp,User
conformed.factchangerequests,ServiceNow,ApprovalHistory,string,User
conformed.factchangerequests,ServiceNow,ProductionSystem,string,User
conformed.factchangerequests,ServiceNow,Parent,string,User
conformed.factchangerequests,ServiceNow,Risk,string,User
conformed.factchangerequests,ServiceNow,Reason,string,User
conformed.factchangerequests,ServiceNow,CorrelationId,string,User
conformed.factchangerequests,ServiceNow,Category,string,User
conformed.factchangerequests,ServiceNow,ActivityDue,timestamp,User
conformed.factchangerequests,ServiceNow,WorkNotesList,string,User
conformed.factchangerequests,ServiceNow,CMDBCI,string,User
conformed.factchangerequests,ServiceNow,CorrelationDisplay,string,User
conformed.factchangerequests,ServiceNow,BusinessDuration,interval,User
conformed.factchangerequests,ServiceNow,TestPlan,string,User
conformed.factchangerequests,ServiceNow,Knowledge,boolean,User
conformed.factchangerequests,ServiceNow,Order,string,User
conformed.factchangerequests,ServiceNow,SLADue,string,User
conformed.factchangerequests,ServiceNow,CABRecommendation,string,User
conformed.factchangerequests,ServiceNow,Type,string,User
conformed.factchangerequests,ServiceNow,CommentsAndWorkNotes,string,User
conformed.factchangerequests,ServiceNow,Justification,string,User
conformed.factchangerequests,ServiceNow,ReviewDate,timestamp,User
conformed.factchangerequests,ServiceNow,SysDomain,string,User
conformed.factchangerequests,ServiceNow,GroupList,string,User
conformed.factchangerequests,ServiceNow,Location,string,User
conformed.factchangerequests,ServiceNow,WorkStart,timestamp,User
conformed.factchangerequests,ServiceNow,CalendarDuration,interval,User
conformed.factchangerequests,ServiceNow,ApprovalSet,string,User
conformed.factchangerequests,ServiceNow,WorkEnd,timestamp,User
conformed.factchangerequests,ServiceNow,SysCreatedOn,timestamp,User
conformed.factchangerequests,ServiceNow,Phase,string,User
conformed.factchangerequests,ServiceNow,CABDate,timestamp,User
conformed.factchangerequests,ServiceNow,SysClassName,string,User
conformed.factchangerequests,ServiceNow,AdditionalAssigneeList,string,User
conformed.factchangerequests,ServiceNow,ConflictStatus,string,User
conformed.factchangerequests,ServiceNow,UponApproval,string,User
conformed.factchangerequests,ServiceNow,FollowUp,string,User
conformed.factchangerequests,ServiceNow,Company,string,User
conformed.factchangerequests,ServiceNow,Active,boolean,User
conformed.factchangerequests,ServiceNow,SysDomainPath,string,User
conformed.factchangerequests,ServiceNow,WorkNotes,string,User
conformed.factchangerequests,ServiceNow,SysModCount,integer,User
conformed.factchangerequests,ServiceNow,Escalation,string,User
conformed.factchangerequests,ServiceNow,ClosedAt,timestamp,User
conformed.factchangerequests,ServiceNow,EndDate,timestamp,User
conformed.factchangerequests,ServiceNow,Approval,string,User
conformed.factchangerequests,ServiceNow,UserInput,string,User
conformed.factchangerequests,ServiceNow,UponReject,string,User
conformed.factchangerequests,ServiceNow,Impact,string,User
conformed.factchangerequests,ServiceNow,ReassignmentCount,integer,User
conformed.factchangerequests,ServiceNow,PhaseState,string,User
conformed.factchangerequests,ServiceNow,State,string,User
conformed.factchangerequests,ServiceNow,StartDate,timestamp,User
conformed.factchangerequests,ServiceNow,OutsideMaintenanceSchedule,boolean,User
conformed.factchangerequests,ServiceNow,SysTags,string,User
conformed.factchangerequests,ServiceNow,Scope,string,User
conformed.factchangerequests,ServiceNow,Priority,string,User
conformed.factchangerequests,ServiceNow,ExpectedStart,timestamp,User
conformed.factchangerequests,ServiceNow,ContactType,string,User
conformed.factchangerequests,ServiceNow,Urgency,string,User
conformed.factchangerequests,ServiceNow,DueDate,timestamp,User
conformed.factchangerequests,ServiceNow,AssignmentGroup,string,User
conformed.factchangerequests,ServiceNow,OpenedAt,timestamp,User
conformed.factchangerequests,ServiceNow,ReviewStatus,string,User
conformed.factchangerequests,ServiceNow,ConflictLastRun,timestamp,User
conformed.factchangerequests,ServiceNow,ReviewComments,string,User
conformed.factchangerequests,ServiceNow,ImplementationPlan,string,User
conformed.factchangerequests,ServiceNow,CABDelegate,timestamp,User
conformed.factchangerequests,ServiceNow,Contract,string,User
conformed.factchangerequests,ServiceNow,RejectionGoto,string,User
conformed.factchangerequests,ServiceNow,WFActivity,string,User
conformed.factchangerequests,ServiceNow,UniversalRequest,string,User
conformed.factchangerequests,ServiceNow,StdChangeProducerVersion,string,User
conformed.factchangerequests,ServiceNow,ServiceOffering,string,User
conformed.factchangerequests,ServiceNow,Variables,string,User
conformed.factchangerequests,ServiceNow,TaskEffectiveNumber,string,User
conformed.factchangerequests,ServiceNow,OnHoldTask,string,User
conformed.factchangerequests,ServiceNow,RouteReason,string,User
conformed.factchangerequests,ServiceNow,ChgModel,string,User
conformed.factchangerequests,ServiceNow,CloseCode,string,User
conformed.factchangerequests,ServiceNow,OnHoldReason,string,User
conformed.factchangerequests,ServiceNow,CABRequired,boolean,User
conformed.factchangerequests,ServiceNow,OnHold,boolean,User
conformed.factchangerequests,ServiceNow,CABDateTime,timestamp,User
conformed.factchangerequests,ServiceNow,Unauthorized,boolean,User
conformed.factchangerequests,ServiceNow,RiskImpactAnalysis,string,User
conformed.factincidents,ServiceNow,CreatedByUser,string,User
conformed.factincidents,ServiceNow,UserKey,bigint,User
conformed.factincidents,ServiceNow,IncidentNumber,string,User
conformed.factincidents,ServiceNow,SysUpdatedOn,timestamp,User
conformed.factincidents,ServiceNow,SysUpdatedOnDateKey,bigint,User
conformed.factincidents,ServiceNow,Active,Boolean,User
conformed.factincidents,ServiceNow,AssignmentGroup,string,User
conformed.factincidents,ServiceNow,BusinessImpact,string,User
conformed.factincidents,ServiceNow,Category,string,User
conformed.factincidents,ServiceNow,Cause,string,User
conformed.factincidents,ServiceNow,CausedBy,string,User
conformed.factincidents,ServiceNow,ChildIncidents,string,User
conformed.factincidents,ServiceNow,ClosedAt,timestamp,User
conformed.factincidents,ServiceNow,ClosedAtDateKey,bigint,User
conformed.factincidents,ServiceNow,Company,string,User
conformed.factincidents,ServiceNow,Escalation,string,User
conformed.factincidents,ServiceNow,Impact,string,User
conformed.factincidents,ServiceNow,IncidentState,string,User
conformed.factincidents,ServiceNow,MadeSLA,boolean,User
conformed.factincidents,ServiceNow,OpenedAt,timestamp,User
conformed.factincidents,ServiceNow,OpenedAtDateKey,bigint,User
conformed.factincidents,ServiceNow,Priority,string,User
conformed.factincidents,ServiceNow,ProblemID,string,User
conformed.factincidents,ServiceNow,ReassignmentCount,integer,User
conformed.factincidents,ServiceNow,ReopenCount,integer,User
conformed.factincidents,ServiceNow,ResolvedAt,timestamp,User
conformed.factincidents,ServiceNow,ResolvedAtDateKey,bigint,User
conformed.factincidents,ServiceNow,Severity,string,User
conformed.factincidents,ServiceNow,State,string,User
conformed.factincidents,ServiceNow,Subcategory,string,User
conformed.factincidents,ServiceNow,SysClassName,string,User
conformed.factincidents,ServiceNow,SysCreatedOn,timestamp,User
conformed.factincidents,ServiceNow,SysCreatedOnDateKey,bigint,User
conformed.factincidents,ServiceNow,SysID,string,User
conformed.factincidents,ServiceNow,TaskEffectiveNumber,string,User
conformed.factincidents,ServiceNow,Urgency,string,User
conformed.factincidents,ServiceNow,IncidentDurationHrs,integer,User
conformed.factemailactivity,Graph,EmailActivityKey,bigint,User
conformed.factemailactivity,Graph,UserKey,long,User
conformed.factemailactivity,Graph,RefreshDateKey,bigint,User
conformed.factemailactivity,Graph,UserID,string,User
conformed.factemailactivity,Graph,IsDeleted,boolean,User
conformed.factemailactivity,Graph,DeletedDateKey,bigint,User
conformed.factemailactivity,Graph,LastActivityDateKey,bigint,User
conformed.factemailactivity,Graph,SendCount,int,User
conformed.factemailactivity,Graph,ReceiveCount,int,User
conformed.factemailactivity,Graph,ReadCount,int,User
conformed.factemailactivity,Graph,MeetingCreatedCount,int,User
conformed.factemailactivity,Graph,MeetingInteractedCount,int,User
conformed.factemailactivity,Graph,AssignedProducts,string,User
conformed.factemailactivity,Graph,ReportPeriod,int,User
conformed.factoffice365activity,Graph,Office365ActivityKey,bigint,User
conformed.factoffice365activity,Graph,UserKey,long,User
conformed.factoffice365activity,Graph,RefreshDateKey,bigint,User
conformed.factoffice365activity,Graph,IsDeleted,boolean,User
conformed.factoffice365activity,Graph,DeletedDateKey,date,User
conformed.factoffice365activity,Graph,HasExchangeLicense,boolean,User
conformed.factoffice365activity,Graph,HasOneDriveLicense,boolean,User
conformed.factoffice365activity,Graph,HasSharePointLicense,boolean,User
conformed.factoffice365activity,Graph,HasSkypeForBusinessLicense,boolean,User
conformed.factoffice365activity,Graph,HasYammerLicense,boolean,User
conformed.factoffice365activity,Graph,HasTeamsLicense,boolean,User
conformed.factoffice365activity,Graph,ExchangeLastActivityDateKey,date,User
conformed.factoffice365activity,Graph,OneDriveLastActivityDateKey,date,User
conformed.factoffice365activity,Graph,SharePointLastActivityDateKey,date,User
conformed.factoffice365activity,Graph,SkypeForBusinessLastActivityDateKey,date,User
conformed.factoffice365activity,Graph,YammerLastActivityDateKey,date,User
conformed.factoffice365activity,Graph,TeamsLastActivityDateKey,date,User
conformed.factoffice365activity,Graph,ExchangeLicenseAssignDateKey,date,User
conformed.factoffice365activity,Graph,OneDriveLicenseAssignDateKey,date,User
conformed.factoffice365activity,Graph,SharePointLicenseAssignDateKey,date,User
conformed.factoffice365activity,Graph,SkypeForBusinessLicenseAssignDateKey,date,User
conformed.factoffice365activity,Graph,YammerLicenseAssignDateKey,date,User
conformed.factoffice365activity,Graph,TeamsLicenseAssignDateKey,date,User
conformed.factoffice365activity,Graph,AssignedProducts,string,User
conformed.factoffice365activity,Graph,UserID,string,User
conformed.factbonusplan,Workday,CompensationKey,long,User
conformed.factbonusplan,Workday,UserKey,long,User
conformed.factbonusplan,Workday,EffectiveDateKey,long,User
conformed.factbonusplan,Workday,WorkerID,string,User
conformed.factbonusplan,Workday,CompPlanRef,string,User
conformed.factbonusplan,Workday,CompElementRef,string,User
conformed.factbonusplan,Workday,IndividualTargetAmount,decimal,User
conformed.factbonusplan,Workday,DefaultTargetAmount,decimal,User
conformed.factbonusplan,Workday,DefaultTargetPercent,decimal,User
conformed.factbonusplan,Workday,GuaranteedMinimum,decimal,User
conformed.factbonusplan,Workday,PercentAssigned,decimal,User
conformed.factbonusplan,Workday,Currency,string,User
conformed.factbonusplan,Workday,Frequency,string,User
conformed.factcommissionplan,Workday,CommissionPlanKey,long,User
conformed.factcommissionplan,Workday,UserKey,long,User
conformed.factcommissionplan,Workday,CommissionEffectiveDateKey,long,User
conformed.factcommissionplan,Workday,WorkerID,string,User
conformed.factcommissionplan,Workday,CommissionCompElementRef,string,User
conformed.factcommissionplan,Workday,CommissionCompPlanRef,string,User
conformed.factcommissionplan,Workday,CommissionTargetAmount,decimal,User
conformed.factcommissionplan,Workday,CommissionCurrency,string,User
conformed.factcommissionplan,Workday,CommissionFrequency,string,User
conformed.factcommissionplan,Workday,CommissionDrawAmount,decimal,User
conformed.factcommissionplan,Workday,CommissionDrawFrequency,string,User
conformed.factcommissionplan,Workday,CommissionRecoverable,boolean,User
conformed.factcompensation,Workday,CompensationKey,long,User
conformed.factcompensation,Workday,WorkerID,string,User
conformed.factcompensation,Workday,UserKey,long,User
conformed.factcompensation,Workday,CompEffectiveDateKey,long,User
conformed.factcompensation,Workday,CompProgressionStartDateKey,long,User
conformed.factcompensation,Workday,CompensationPackageID,string,User
conformed.factcompensation,Workday,CompensationStepID,string,User
conformed.factcompensation,Workday,Currency,string,User
conformed.factcompensation,Workday,PrimaryBasis,decimal,User
conformed.factcompensation,Workday,TotalBasePay,decimal,User
conformed.factcompensation,Workday,PayFrequency,string,User
conformed.factemployment,Workday,EmploymentKey,bigint,User
conformed.factemployment,Workday,UserKey,bigint,User
conformed.factemployment,Workday,JobProfileKey,bigint,User
conformed.factemployment,Workday,BusinessSiteKey,bigint,User
conformed.factemployment,Workday,PayrollEffectiveDateKey,bigint,User
conformed.factemployment,Workday,AddressEffectiveDateKey,bigint,User
conformed.factemployment,Workday,PositionEffectiveDateKey,bigint,User
conformed.factemployment,Workday,WorkerId,string,User
conformed.factemployment,Workday,InternationalAssignment,boolean,User
conformed.factemployment,Workday,PrimaryJob,boolean,User
conformed.factemployment,Workday,BusinessTitle,string,User
conformed.factemployment,Workday,EndDateKey,bigint,User
conformed.factemployment,Workday,DefaultWeeklyHours,decimal,User
conformed.factemployment,Workday,ExcludeFromHeadcount,boolean,User
conformed.factemployment,Workday,FederalWithholdingFEIN,string,User
conformed.factemployment,Workday,FullTimeEquivPercentage,decimal,User
conformed.factemployment,Workday,JobExempt,boolean,User
conformed.factemployment,Workday,ManagerId,string,User
conformed.factemployment,Workday,PaidFTE,decimal,User
conformed.factemployment,Workday,PayRateTypeRef,string,User
conformed.factemployment,Workday,PayRateType,string,User
conformed.factemployment,Workday,PositionId,string,User
conformed.factemployment,Workday,PositionRef,string,User
conformed.factemployment,Workday,PositionTimeTypeRef,string,User
conformed.factemployment,Workday,PositionTimeType,string,User
conformed.factemployment,Workday,PositionTitle,string,User
conformed.factemployment,Workday,RegularPaidEquivHours,decimal,User
conformed.factemployment,Workday,ScheduledWeeklyHours,decimal,User
conformed.factemployment,Workday,SpecifyPaidFTE,boolean,User
conformed.factemployment,Workday,SpecifyWorkingFTE,boolean,User
conformed.factemployment,Workday,StartDateKey,bigint,User
conformed.factemployment,Workday,WorkspaceRef,string,User
conformed.factemployment,Workday,Workspace,string,User
conformed.factemployment,Workday,WorkerTypeRef,string,User
conformed.factemployment,Workday,WorkerType,string,User
conformed.factemployment,Workday,WorkingFTE,boolean,User
conformed.factemployment,Workday,WorkingTimeValue,decimal,User
conformed.factemployment,Workday,DefaultBusinessSiteAddress,boolean,User
conformed.factemployment,Workday,HomeNumberOfDays,decimal,User
conformed.factemployment,Workday,SiteScheduledWeeklyHours,decimal,User
conformed.factemployment,Workday,JPJobExempt,boolean,User
conformed.factemployment,Workday,PayrollFrequencyRef,string,User
conformed.factemployment,Workday,PayrollFrequency,string,User
conformed.factemployment,Workday,PayrollPayRateTypeRef,string,User
conformed.factemployment,Workday,PayrollPayRateType,string,User
conformed.factemployment,Workday,Active,boolean,User
conformed.factemployment,Workday,ActiveStatusDateKey,bigint,User
conformed.factemployment,Workday,ContinuousServiceDateKey,bigint,User
conformed.factemployment,Workday,DaysUnemployed,decimal,User
conformed.factemployment,Workday,FirstDayOfWorkKey,bigint,User
conformed.factemployment,Workday,HireDateKey,bigint,User
conformed.factemployment,Workday,HireRescinded,boolean,User
conformed.factemployment,Workday,MonthsContinuousPriorEmployment,decimal,User
conformed.factemployment,Workday,NotReturning,boolean,User
conformed.factemployment,Workday,OrigHireDateKey,bigint,User
conformed.factemployment,Workday,RegrettableTermination,boolean,User
conformed.factemployment,Workday,Rehire,boolean,User
conformed.factemployment,Workday,Retired,boolean,User
conformed.factemployment,Workday,ReturnUnknown,boolean,User
conformed.factemployment,Workday,SeniorityDateKey,bigint,User
conformed.factemployment,Workday,Terminated,boolean,User
conformed.factdeviceperformance,Nexthink,DevicePerfKey,bigint,Device
conformed.factdeviceperformance,Nexthink,DevicePerfDateKey,bigint,Device
conformed.factdeviceperformance,Nexthink,DeviceKey,bigint,Device
conformed.factdeviceperformance,Nexthink,DeviceSID,string,Device
conformed.factdeviceperformance,Nexthink,AvgDeviceReadyTime,decimal,Device
conformed.factdeviceperformance,Nexthink,AvgWifiTransRate,decimal,Device
conformed.factdeviceperformance,Nexthink,AvgBootTime7d,decimal,Device
conformed.factdeviceperformance,Nexthink,AvgWifiStrength,decimal,Device
conformed.factdeviceperformance,Nexthink,NumBoots7d,decimal,Device
conformed.factdeviceperformance,Nexthink,InstalledMemory,decimal,Device
conformed.factdeviceperformance,Nexthink,FreeMemory,decimal,Device
conformed.factdeviceperformance,Nexthink,NumErrors,decimal,Device
conformed.factdeviceperformance,Nexthink,NumAlerts,decimal,Device
conformed.factdeviceperformance,Nexthink,NumHardResets,decimal,Device
conformed.factdeviceperformance,Nexthink,NumSystemCrashes7d,decimal,Device
conformed.factdeviceperformance,Nexthink,NumAppCrashes7d,decimal,Device
conformed.factdexscore,Nexthink,DexScoreKey,bigint,Device
conformed.factdexscore,Nexthink,UserKey,bigint,Device
conformed.factdexscore,Nexthink,DeviceKey,bigint,Device
conformed.factdexscore,Nexthink,UserSID,string,Device
conformed.factdexscore,Nexthink,DeviceSID,string,Device
conformed.factdexscore,Nexthink,DexScoreValue,decimal,Device
conformed.factdexscore,Nexthink,DexScoreDateKey,bigint,Device
conformed.factdexscore,Nexthink,CollaborationValue,decimal,Device
conformed.factdexscore,Nexthink,TeamsValue,decimal,Device
conformed.factdexscore,Nexthink,TeamsAudioQualityValue,decimal,Device
conformed.factdexscore,Nexthink,TeamsVideoQualityValue,decimal,Device
conformed.factdexscore,Nexthink,ZoomValue,decimal,Device
conformed.factdexscore,Nexthink,ZoomAudioQualityValue,decimal,Device
conformed.factdexscore,Nexthink,ZoomVideoQualityValue,decimal,Device
conformed.factdexscore,Nexthink,LogonSpeedValue,decimal,Device
conformed.factdexscore,Nexthink,OsActivationValue,decimal,Device
conformed.factdexscore,Nexthink,SoftwarePerformanceValue,decimal,Device
conformed.factdexscore,Nexthink,SoftwarePerformanceWithGUIValue,decimal,Device
conformed.factdexscore,Nexthink,SoftwarePerformanceWithoutGUIValue,decimal,Device
conformed.factdexscore,Nexthink,SoftwareReliabilityValue,decimal,Device
conformed.factdexscore,Nexthink,SoftwareReliabilityWithoutGUIValue,decimal,Device
conformed.factdexscore,Nexthink,SoftwareReliabilityWithGUIValue,decimal,Device
conformed.factdexscore,Nexthink,EndpointValue,decimal,Device
conformed.factdexscore,Nexthink,TecnologyValue,decimal,Device
conformed.factucclientreadinessstatus,Log Analytics,UUClientReadinessStatusKey,bigint,Device
conformed.factucclientreadinessstatus,Log Analytics,DeviceKey,bigint,Device
conformed.factucclientreadinessstatus,Log Analytics,TenantId,string,Device
conformed.factucclientreadinessstatus,Log Analytics,TimeGenerated,timestamp,Device
conformed.factucclientreadinessstatus,Log Analytics,DeviceName,string,Device
conformed.factucclientreadinessstatus,Log Analytics,GlobalDeviceId,string,Device
conformed.factucclientreadinessstatus,Log Analytics,AzureADTenantId,string,Device
conformed.factucclientreadinessstatus,Log Analytics,AzureADDeviceId,string,Device
conformed.factucclientreadinessstatus,Log Analytics,SCCMClientId,string,Device
conformed.factucclientreadinessstatus,Log Analytics,OSName,string,Device
conformed.factucclientreadinessstatus,Log Analytics,OSVersion,string,Device
conformed.factucclientreadinessstatus,Log Analytics,OSBuild,string,Device
conformed.factucclientreadinessstatus,Log Analytics,TargetOSName,string,Device
conformed.factucclientreadinessstatus,Log Analytics,TargetOSVersion,string,Device
conformed.factucclientreadinessstatus,Log Analytics,TargetOSBuild,string,Device
conformed.factucclientreadinessstatus,Log Analytics,ReadinessStatus,string,Device
conformed.factucclientreadinessstatus,Log Analytics,ReadinessReason,string,Device
conformed.factucclientreadinessstatus,Log Analytics,ReadinessScanTime,timestamp,Device
conformed.factucclientreadinessstatus,Log Analytics,ReadinessExpiryTime,timestamp,Device
conformed.factucclientreadinessstatus,Log Analytics,SetupReadinessStatus,string,Device
conformed.factucclientreadinessstatus,Log Analytics,SetupReadinessReason,string,Device
conformed.factucclientreadinessstatus,Log Analytics,SetupReadinessTime,timestamp,Device
conformed.factucclientreadinessstatus,Log Analytics,SetupReadinessExpiryTime,timestamp,Device
conformed.factucclientreadinessstatus,Log Analytics,SourceSystem,string,Device
conformed.factucclientreadinessstatus,Log Analytics,Type,string,Device
conformed.factucdoaggregatedstatus,Log Analytics,UCDOAggregatedStatusKey,bigint,Device
conformed.factucdoaggregatedstatus,Log Analytics,TenantId ,string,Device
conformed.factucdoaggregatedstatus,Log Analytics,TimeGenerated,timestamp,Device
conformed.factucdoaggregatedstatus,Log Analytics,AzureADTenantId ,string,Device
conformed.factucdoaggregatedstatus,Log Analytics,AzureADDeviceId ,string,Device
conformed.factucdoaggregatedstatus,Log Analytics,DeviceCount,bigint,Device
conformed.factucdoaggregatedstatus,Log Analytics,ContentType,string,Device
conformed.factucdoaggregatedstatus,Log Analytics,BytesFromCDN,bigint,Device
conformed.factucdoaggregatedstatus,Log Analytics,BytesFromIntPeers,bigint,Device
conformed.factucdoaggregatedstatus,Log Analytics,BytesFromPeers,bigint,Device
conformed.factucdoaggregatedstatus,Log Analytics,BytesFromGroupPeers,bigint,Device
conformed.factucdoaggregatedstatus,Log Analytics,BytesFromCache,bigint,Device
conformed.factucdoaggregatedstatus,Log Analytics,BWOptPercent28Days,decimal,Device
conformed.factucdoaggregatedstatus,Log Analytics,SourceSystem,string,Device
conformed.factucdoaggregatedstatus,Log Analytics,Type,string,Device
conformed.factapprevisions,Intune,appKey,string,Application
conformed.factapprevisions,Intune,applicationId,string,Application
conformed.factapprevisions,Intune,revision,string,Application
conformed.factapprevisions,Intune,title,string,Application
conformed.factapprevisions,Intune,publisher,string,Application
conformed.factapprevisions,Intune,appTypeKey,string,Application
conformed.factapprevisions,Intune,vppProgramTypeKey,string,Application
conformed.factapprevisions,Intune,size,integer,Application
conformed.factapprevisions,Intune,isCurrent,boolean,Application
conformed.factapprevisions,Intune,isDeleted,boolean,Application
conformed.factapprevisions,Intune,startDateInclusiveUTC,timestamp,Application
conformed.factapprevisions,Intune,endDateExclusiveUTC,timestamp,Application
conformed.factapprevisions,Intune,rowLastModifiedDateTimeUTC,timestamp,Application
conformed.factmobileappinstallstatuscounts,Intune,MobAppInstStatID,bigint,Application
conformed.factmobileappinstallstatuscounts,Intune,dateKey,string,Application
conformed.factmobileappinstallstatuscounts,Intune,appKey,string,Application
conformed.factmobileappinstallstatuscounts,Intune,deviceTypeKey,string,Application
conformed.factmobileappinstallstatuscounts,Intune,appInstallStateKey,string,Application
conformed.factmobileappinstallstatuscounts,Intune,errorCode,string,Application
conformed.factmobileappinstallstatuscounts,Intune,count,integer,Application
conformed.factreservations,SeviceNow,ReservationKey,bigint,Physical
conformed.factreservations,SeviceNow,SysId,string,Physical
conformed.factreservations,SeviceNow,Number,string,Physical
conformed.factreservations,SeviceNow,SysUpdatedOn,timestamp,Physical
conformed.factreservations,SeviceNow,SysUpdatedOnDateKey,bigint,Physical
conformed.factreservations,SeviceNow,Active,boolean,Physical
conformed.factreservations,SeviceNow,AdditionalInfo,string,Physical
conformed.factreservations,SeviceNow,AdditionalMessage,string,Physical
conformed.factreservations,SeviceNow,AlternativeExternalId,string,Physical
conformed.factreservations,SeviceNow,AssociatedFlows,string,Physical
conformed.factreservations,SeviceNow,Attendees,string,Physical
conformed.factreservations,SeviceNow,AutoConflictResolutionState,string,Physical
conformed.factreservations,SeviceNow,BlockReference,string,Physical
conformed.factreservations,SeviceNow,BlockerFor,string,Physical
conformed.factreservations,SeviceNow,Building,string,Physical
conformed.factreservations,SeviceNow,BuildingKey,bigint,Physical
conformed.factreservations,SeviceNow,CancelNotes,string,Physical
conformed.factreservations,SeviceNow,CancelingSeries,boolean,Physical
conformed.factreservations,SeviceNow,CheckInState,string,Physical
conformed.factreservations,SeviceNow,CheckInTime,timestamp,Physical
conformed.factreservations,SeviceNow,CheckInDateKey,bigint,Physical
conformed.factreservations,SeviceNow,CheckOutTime,timestamp,Physical
conformed.factreservations,SeviceNow,CheckOutDateKey,bigint,Physical
conformed.factreservations,SeviceNow,ConfigurationItem,string,Physical
conformed.factreservations,SeviceNow,CoreRSVOpenedBy,string,Physical
conformed.factreservations,SeviceNow,CostCenter,string,Physical
conformed.factreservations,SeviceNow,EditRestriction,string,Physical
conformed.factreservations,SeviceNow,End,timestamp,Physical
conformed.factreservations,SeviceNow,EndDateKey,bigint,Physical
conformed.factreservations,SeviceNow,ExternalId,string,Physical
conformed.factreservations,SeviceNow,ExternalOccurrenceId,string,Physical
conformed.factreservations,SeviceNow,ExternalSeriesMasterId,string,Physical
conformed.factreservations,SeviceNow,Floor,string,Physical
conformed.factreservations,SeviceNow,FloorKey,bigint,Physical
conformed.factreservations,SeviceNow,IsParent,boolean,Physical
conformed.factreservations,SeviceNow,IsPrivate,boolean,Physical
conformed.factreservations,SeviceNow,JoinInfo,string,Physical
conformed.factreservations,SeviceNow,LastUpdatedSource,string,Physical
conformed.factreservations,SeviceNow,LastUpdatedSubSource,string,Physical
conformed.factreservations,SeviceNow,Location,string,Physical
conformed.factreservations,SeviceNow,MeetingExtraData,string,Physical
conformed.factreservations,SeviceNow,MeetingId,string,Physical
conformed.factreservations,SeviceNow,Neighborhood,string,Physical
conformed.factreservations,SeviceNow,NotificationCustomMessage,string,Physical
conformed.factreservations,SeviceNow,NotificationRecipients,string,Physical
conformed.factreservations,SeviceNow,NumberOfAttendees,integer,Physical
conformed.factreservations,SeviceNow,PrivateSubject,string,Physical
conformed.factreservations,SeviceNow,RecurringPattern,string,Physical
conformed.factreservations,SeviceNow,RelatedCase,string,Physical
conformed.factreservations,SeviceNow,RequestedFor,string,Physical
conformed.factreservations,SeviceNow,ReservableModule,string,Physical
conformed.factreservations,SeviceNow,ReservableModuleKey,bigint,Physical
conformed.factreservations,SeviceNow,ReservationPath,string,Physical
conformed.factreservations,SeviceNow,ReservationPurpose,integer,Physical
conformed.factreservations,SeviceNow,ReservationSubtype,string,Physical
conformed.factreservations,SeviceNow,ReservationType,string,Physical
conformed.factreservations,SeviceNow,RSVSpanDays,string,Physical
conformed.factreservations,SeviceNow,Sensitivity,string,Physical
conformed.factreservations,SeviceNow,SGArea,string,Physical
conformed.factreservations,SeviceNow,SGLocations,string,Physical
conformed.factreservations,SeviceNow,SGUserNearbyLocation,string,Physical
conformed.factreservations,SeviceNow,Shift,string,Physical
conformed.factreservations,SeviceNow,ShortDescription,string,Physical
conformed.factreservations,SeviceNow,SourceReservation,string,Physical
conformed.factreservations,SeviceNow,Source,string,Physical
conformed.factreservations,SeviceNow,SourceVisit,string,Physical
conformed.factreservations,SeviceNow,Start,timestamp,Physical
conformed.factreservations,SeviceNow,StartDateKey,bigint,Physical
conformed.factreservations,SeviceNow,State,string,Physical
conformed.factreservations,SeviceNow,SubSource,string,Physical
conformed.factreservations,SeviceNow,Subject,string,Physical
conformed.factreservations,SeviceNow,SyncState,string,Physical
conformed.factreservations,SeviceNow,SysClassName,string,Physical
conformed.factreservations,SeviceNow,SysCreatedBy,string,Physical
conformed.factreservations,SeviceNow,SysCreatedByUserKey,bigint,Physical
conformed.factreservations,SeviceNow,SysCreatedOn,timestamp,Physical
conformed.factreservations,SeviceNow,SysCreatedOnDateKey,bigint,Physical
conformed.factreservations,SeviceNow,SysDomain,timestamp,Physical
conformed.factreservations,SeviceNow,SysModCount,integer,Physical
conformed.factreservations,SeviceNow,SysTags,string,Physical
conformed.factreservations,SeviceNow,SysUpdatedBy,string,Physical
conformed.factreservations,SeviceNow,SysUpdatedByUserKey,bigint,Physical
conformed.factreservations,SeviceNow,VirtualMeetingProvider,string,Physical
conformed.factreservations,SeviceNow,VirtualMeeting,string,Physical
conformed.factreservations,SeviceNow,Visitors,string,Physical
conformed.factreservations,SeviceNow,WorkplaceLocation,string,Physical
conformed.factreservations,SeviceNow,WorkplaceRequest,string,Physical
conformed.factreservations,SeviceNow,WSDApprovalHistory,string,Physical
conformed.factreservations,SeviceNow,WSDApproval,string,Physical
conformed.FactProblems,SeviceNow,ProblemKey,bigint,Service
conformed.FactProblems,SeviceNow,SysId,string,Service
conformed.FactProblems,SeviceNow,Number,string,Service
conformed.FactProblems,SeviceNow,DeliveryPlan,string,Service
conformed.FactProblems,SeviceNow,ApprovalSet,timestamp,Service
conformed.FactProblems,SeviceNow,WorkEnd,timestamp,Service
conformed.FactProblems,SeviceNow,DeliveryTask,string,Service
conformed.FactProblems,SeviceNow,SysCreatedOn,timestamp,Service
conformed.FactProblems,SeviceNow,BusinessService,string,Service
conformed.FactProblems,SeviceNow,ReassignmentCount,int,Service
conformed.FactProblems,SeviceNow,Description,string,Service
conformed.FactProblems,SeviceNow,TimeWorked,string,Service
conformed.FactProblems,SeviceNow,MadeSLA,boolean,Service
conformed.FactProblems,SeviceNow,SysClassName,string,Service
conformed.FactProblems,SeviceNow,WatchList,string,Service
conformed.FactProblems,SeviceNow,AdditionalAssigneeList,string,Service
conformed.FactProblems,SeviceNow,CorrelationID,string,Service
conformed.FactProblems,SeviceNow,SysTags,string,Service
conformed.FactProblems,SeviceNow,UponApproval,string,Service
conformed.FactProblems,SeviceNow,FollowUp,timestamp,Service
conformed.FactProblems,SeviceNow,Company,string,Service
conformed.FactProblems,SeviceNow,Active,boolean,Service
conformed.FactProblems,SeviceNow,Comments,string,Service
conformed.FactProblems,SeviceNow,ProblemState,int,Service
conformed.FactProblems,SeviceNow,SysDomainPath,string,Service
conformed.FactProblems,SeviceNow,ShortDescription,string,Service
conformed.FactProblems,SeviceNow,ApprovalHistory,string,Service
conformed.FactProblems,SeviceNow,RelatedIncidents,int,Service
conformed.FactProblems,SeviceNow,WorkNotes,string,Service
conformed.FactProblems,SeviceNow,RFC,string,Service
conformed.FactProblems,SeviceNow,SysModCount,int,Service
conformed.FactProblems,SeviceNow,Escalation,int,Service
conformed.FactProblems,SeviceNow,AssignedTo,bigint,Service
conformed.FactProblems,SeviceNow,Order,int,Service
conformed.FactProblems,SeviceNow,SysUpdatedOn,timestamp,Service
conformed.FactProblems,SeviceNow,ClosedAt,timestamp,Service
conformed.FactProblems,SeviceNow,Approval,string,Service
conformed.FactProblems,SeviceNow,SysCreatedBy,bigint,Service
conformed.FactProblems,SeviceNow,UserInput,string,Service
conformed.FactProblems,SeviceNow,WorkAround,string,Service
conformed.FactProblems,SeviceNow,UponReject,string,Service
conformed.FactProblems,SeviceNow,Impact,int,Service
conformed.FactProblems,SeviceNow,WorkNotesList,string,Service
conformed.FactProblems,SeviceNow,SysUpdatedBy,bigint,Service
conformed.FactProblems,SeviceNow,WorkStart,timestamp,Service
conformed.FactProblems,SeviceNow,CMDBCI,string,Service
conformed.FactProblems,SeviceNow,CorrelationDisplay,string,Service
conformed.FactProblems,SeviceNow,KnownError,boolean,Service
conformed.FactProblems,SeviceNow,BusinessDuration,string,Service
conformed.FactProblems,SeviceNow,State,string,Service
conformed.FactProblems,SeviceNow,DueDate,timestamp,Service
conformed.FactProblems,SeviceNow,Knowledge,boolean,Service
conformed.FactProblems,SeviceNow,Priority,int,Service
conformed.FactProblems,SeviceNow,ExpectedStart,timestamp,Service
conformed.FactProblems,SeviceNow,Parent,string,Service
conformed.FactProblems,SeviceNow,CommentsAndWorkNotes,string,Service
conformed.FactProblems,SeviceNow,ContactType,string,Service
conformed.FactProblems,SeviceNow,SLADue,timestamp,Service
conformed.FactProblems,SeviceNow,SysDomain,string,Service
conformed.FactProblems,SeviceNow,Location,string,Service
conformed.FactProblems,SeviceNow,Urgency,int,Service
conformed.FactProblems,SeviceNow,GroupList,string,Service
conformed.FactProblems,SeviceNow,ClosedBy,bigint,Service
conformed.FactProblems,SeviceNow,ActivityDue,timestamp,Service
conformed.FactProblems,SeviceNow,CloseNotes,string,Service
conformed.FactProblems,SeviceNow,AssignmentGroup,string,Service
conformed.FactProblems,SeviceNow,OpenedAt,timestamp,Service
conformed.FactProblems,SeviceNow,OpenedBy,bigint,Service
conformed.FactProblems,SeviceNow,CalendarDuration,string,Service
conformed.FactProblems,SeviceNow,FixCommunicatedBy,bigint,Service
conformed.FactProblems,SeviceNow,MajorProblem,boolean,Service
conformed.FactProblems,SeviceNow,Contract,string,Service
conformed.FactProblems,SeviceNow,RejectionGoto,string,Service
conformed.FactProblems,SeviceNow,WFActivity,string,Service
conformed.FactProblems,SeviceNow,UniversalRequest,string,Service
conformed.FactProblems,SeviceNow,ServiceOffering,string,Service
conformed.FactProblems,SeviceNow,ReopenedBy,bigint,Service
conformed.FactProblems,SeviceNow,ConfirmedAt,timestamp,Service
conformed.FactProblems,SeviceNow,Variables,string,Service
conformed.FactProblems,SeviceNow,ConfirmedBy,string,Service
conformed.FactProblems,SeviceNow,FirstReportedByTask,string,Service
conformed.FactProblems,SeviceNow,CauseNotes,string,Service
conformed.FactProblems,SeviceNow,TaskEffectiveNumber,string,Service
conformed.FactProblems,SeviceNow,FixAt,timestamp,Service
conformed.FactProblems,SeviceNow,ResolvedBy,bigint,Service
conformed.FactProblems,SeviceNow,RouteReason,int,Service
conformed.FactProblems,SeviceNow,ResolvedAt,timestamp,Service
conformed.FactProblems,SeviceNow,Subcategory,string,Service
conformed.FactProblems,SeviceNow,ReopenedAt,timestamp,Service
conformed.FactProblems,SeviceNow,FixBy,bigint,Service
conformed.FactProblems,SeviceNow,ResolutionCode,string,Service
conformed.FactProblems,SeviceNow,WorkaroundCommunicatedBy,string,Service
conformed.FactProblems,SeviceNow,ReviewOutcome,string,Service
conformed.FactProblems,SeviceNow,FixCommunicatedAt,timestamp,Service
conformed.FactProblems,SeviceNow,ReopenCount,int,Service
conformed.FactProblems,SeviceNow,DuplicateOf,string,Service
conformed.FactProblems,SeviceNow,WorkaroundCommunicatedAt,timestamp,Service
conformed.FactProblems,SeviceNow,Category,string,Service
conformed.FactProblems,SeviceNow,FixNotes,string,Service
conformed.FactProblems,SeviceNow,WorkAroundApplied,boolean,Service
conformed.FactO365LicenseTrends,Surveil,LicenseKey,bigint,Platform
conformed.FactO365LicenseTrends,Surveil,SkuId,string,Platform
conformed.FactO365LicenseTrends,Surveil,ReportRefreshDateKey,bigint,Platform
conformed.FactO365LicenseTrends,Surveil,ReportRefreshDate,timestamp,Platform
conformed.FactO365LicenseTrends,Surveil,TenantId,string,Platform
conformed.FactO365LicenseTrends,Surveil,AppliesTo,string,Platform
conformed.FactO365LicenseTrends,Surveil,Purchased,integer,Platform
conformed.FactO365LicenseTrends,Surveil,Consumed,integer,Platform
conformed.FactO365LicenseTrends,Surveil,Available,integer,Platform
conformed.FactO365LicenseTrends,Surveil,Suspended,integer,Platform
conformed.FactO365LicenseTrends,Surveil,Warning,integer,Platform
conformed.FactO365LicenseTrends,Surveil,Cost,decimal,Platform
conformed.FactO365LicenseTrends,Surveil,ItemCost,decimal,Platform
conformed.FactO365LicenseTrends,Surveil,PaymentCycle,string,Platform
conformed.FactO365LicenseTrends,Surveil,ExpirationDate,timestamp,Platform
conformed.FactO365LicenseTrends,Surveil,ExpirationDateKey,bigint,Platform
conformed.FactO365LicenseTrends,Surveil,Plans,string,Platform
conformed.FactO365LicenseTrends,Surveil,ReportPeriod,integer,Platform
conformed.FactO365LicenseTrends,Surveil,ReportRefreshDateMonth,timestamp,Platform
conformed.FactO365LicenseTrends,Surveil,ReportRefreshDateMonthKey,bigint,Platform
conformed.FactO365LicenseTrends,Surveil,AssignedUsers,string,Platform
conformed.FactO365LicenseTrends,Surveil,DaysInMonth,integer,Platform
conformed.FactO365LicenseTrends,Surveil,PurchasedEffective,integer,Platform
conformed.FactO365LicenseTrends,Surveil,TenatSKUID,string,Platform
conformed.FactO365LicenseTrends,Surveil,CostConsumedPerDay,decimal,Platform
conformed.FactO365LicenseTrends,Surveil,CostAvailablePerDay,decimal,Platform
conformed.FactO365LicenseTrends,Surveil,CostPurchasedPerDay,decimal,Platform
conformed.FactO365LicenseTrends,Surveil,CostPurchasedEffectivePerDay,decimal,Platform
conformed.FactLicenseAnalysis,Surveil,LicenseAnalysisID,bigint,Platform
conformed.FactLicenseAnalysis,Surveil,UserKey,bigint,Platform
conformed.FactLicenseAnalysis,Surveil,M365Business,INT,Platform
conformed.FactLicenseAnalysis,Surveil,M365E1,INT,Platform
conformed.FactLicenseAnalysis,Surveil,M365E3,INT,Platform
conformed.FactLicenseAnalysis,Surveil,M365E5,INT,Platform
conformed.FactLicenseAnalysis,Surveil,M365F1,INT,Platform
conformed.FactLicenseAnalysis,Surveil,M365F3,INT,Platform
conformed.FactLicenseAnalysis,Surveil,EMSE3,INT,Platform
conformed.FactLicenseAnalysis,Surveil,EMSE5,INT,Platform
conformed.FactLicenseAnalysis,Surveil,EnterpriseE1,INT,Platform
conformed.FactLicenseAnalysis,Surveil,EnterpriseE3,INT,Platform
conformed.FactLicenseAnalysis,Surveil,EnterpriseE5,INT,Platform
conformed.FactLicenseAnalysis,Surveil,OfficeLicenseOverlapCount,INT,Platform
conformed.FactLicenseAnalysis,Surveil,OfficeLicenseOverlap,STRING,Platform
conformed.FactLicenseAnalysis,Surveil,PowerBI,INT,Platform
conformed.FactLicenseAnalysis,Surveil,Project,INT,Platform
conformed.FactLicenseAnalysis,Surveil,Visio,INT,Platform
conformed.FactLicenseAnalysis,Surveil,TenantId,string,Platform
conformed.FactLicenseAnalysis,Surveil,SurveilUserId,string,Platform
conformed.FactLicenseAnalysis,Surveil,AssignedLicenseCount,integer,Platform
conformed.FactLicenseAnalysis,Surveil,RemoveLicense_Certainty,string,Platform
conformed.FactLicenseAnalysis,Surveil,UsersWith365License,integer,Platform
conformed.FactLicenseAnalysis,Surveil,LicenseUsage_UsingPlansFoundInWhichSKUs,string,Platform
conformed.FactLicenseAnalysis,Surveil,AssignedLicenseCost,decimal,Platform
conformed.FactLicenseAnalysis,Surveil,UsersWithProplusActivations_C,integer,Platform
conformed.FactLicenseAnalysis,Surveil,RemoveLicense_Certainty_Masked,string,Platform
conformed.FactLicenseAnalysis,Surveil,HasExchangeLicense,boolean,Platform
conformed.FactLicenseAnalysis,Surveil,HasOneDriveLicense,boolean,Platform
conformed.factazuresecurescore,Graph,SubscriptionKey,bigint,Security
conformed.factazuresecurescore,Graph,SubscriptionId,string,Security
conformed.factazuresecurescore,Graph,SecureControlDisplayName,string,Security
conformed.factazuresecurescore,Graph,CurrentScore,integer,Security
conformed.factazuresecurescore,Graph,MaxScore,integer,Security
conformed.factazuresecurescore,Graph,HealthyResourceCount,integer,Security
conformed.factazuresecurescore,Graph,UnhealthyResourceCount,integer,Security
conformed.factazuresecurescore,Graph,Weight,integer,Security
conformed.factazuresecurescore,Graph,ImprovementAvailable,integer,Security
conformed.factazuresecurescore,Graph,RecordDate,date,Security
conformed.factazuresecurescore,Graph,RecordDateKey,bigint,Security`;





interface WsDecodeLabel {
  table: string;
  field: string;
  type: string;
  source: string;
  entity: string;
}

export const getLabelList = () => {
  const labelList: WsDecodeLabel[] = [];

  const labelStringList = labelString.split(/\r?\n/);



  labelStringList.forEach((labelStringItem) => {

    const labelStringItemProperties = labelStringItem.split(',');

    const labelItem: WsDecodeLabel = {
      table:   `${labelStringItemProperties[0]}`.toLowerCase().split('.')[1],
      field:   `${labelStringItemProperties[2]}`,
      type:    `${labelStringItemProperties[3]}`.toLowerCase(),
      source:  `${labelStringItemProperties[1]}`,
      entity:  `${labelStringItemProperties[4]}`,
    };

    labelList.push(labelItem);

  });




  return labelList.sort((a, b) => {  
    if (a.table.toLowerCase() > b.table.toLowerCase()) return  1;
    if (a.table.toLowerCase() < b.table.toLowerCase()) return -1;

    if (a.field.toLowerCase() > b.field.toLowerCase()) return  1;
    if (a.field.toLowerCase() < b.field.toLowerCase()) return -1;
    return 0;
  });
};











const generateValue = (mMin = 10, mMax = 9000) => {

  const min = Math.ceil(100);
  const max = Math.floor(500);

  const value = Math.floor(Math.random() * (max - min + 1)) + min;

  return value;
};






const generateDataValueList = () => {
  const list: number[] = [];

  const limit = generateValue(250, 2500);

  let i = 0;

  while (i < limit) {

    const value = generateValue();

    list.push(value);

    i++;
  }

  // console.log('============ GENERATEDATAVALUELIST ==========');
  // console.log(list);

  return list;
};






const getConvertedValue = (dataValueList: number[], measurement: WsDecodeMeasurement, baselineValue: number) => {
  let value: number = 0;

  if (dataValueList.length > 0) {

    if (measurement === WsDecodeMeasurement.Count) {

      // COUNT

      value = dataValueList.length;
  
    } else if (measurement === WsDecodeMeasurement.Sum) {

      // SUM
  
      dataValueList.forEach((item) => {
        value += item;
      });
  
    } else {

      // AVERAGE
  
      let total = 0;
  
      dataValueList.forEach((item) => {
        total += item;
      });
  
      value = total / dataValueList.length;
    }

  }

  return value;
};





interface WsMetricStatistic {
  convertedValue: number;
  metricValue:    number;
  baselineValue:  number;
}

const getMetricStatistic = (
  sourceList: WsDecodeSource[] | undefined,
  boardList:  WsDecodeBoardInterface[],
  metric:     WsDecodeMetric,
  dataValueList: ( number | string | boolean )[]
) => {

  const sourceDataValueList: number[] = dataValueList.map((value) => dataValueToNumber(value));



  let baselineValue = metric.baselineValue;

  let convertedValue: number = 0;



  if (isNumeric(metric.sourceId)) {

    // metric value is from board score

    baselineValue = 10;

    // console.log('============= getMetricStatistic ====================');

    const convertedValueFloat = getBoardScorePercent(sourceList, boardList, `${metric.sourceId}`);

    // console.log(convertedValueFloat);

    const convertedValueDecimal = new Decimal(convertedValueFloat);

    // console.log(convertedValueDecimal);

    convertedValue = Number(convertedValueDecimal.div(10).toFixed(1));

    // console.log(convertedValue);



  } else {

    // metric value is static

    if (metric.staticValue && metric.staticValue > 0) {

      convertedValue = metric.staticValue;


    } else {

      // metric value is from source item (data value list)

      convertedValue = getConvertedValue(sourceDataValueList, metric.measurement, baselineValue);
    }
  }



  // let metricValue: number = (convertedValue / 100) * metric.weight;

  let metricValue: number = convertedValue;



  if (baselineValue > 0) {

    if (baselineValue > metricValue) {
      metricValue = (metricValue / baselineValue) * 100;
    } else {
      metricValue = 100;
    }
  }



  const value: WsMetricStatistic = {
    convertedValue,
    metricValue,
    baselineValue
  };

  return value;
};





export const getMetricStatisticValue = (metric: WsDecodeMetric, metricStatistic: WsMetricStatistic) => {

  return metric.scoreView === WsDecodeScoreView.Value ? metricStatistic.convertedValue : metricStatistic.metricValue;

  // metric.scoreView === WsDecodeScoreView.Value ? metricStatistic.convertedValue : metricStatistic.metricValue
};





export const getNumericValueBasedOnFilter = (currentValue: number, filterId: string, index = 0): number => {

  return currentValue * getAdjustmentFactor(filterId, index);

};






export const getMetricScoreBasedOnFilter = (currentMetricScoreFixed: string, filterId: string): string => {

  const currentMetricScoreFixedWithoutPercent = currentMetricScoreFixed.indexOf('%') > -1 ? currentMetricScoreFixed.replace('%', '') : currentMetricScoreFixed;

  const metricScoreNumber = Number(currentMetricScoreFixedWithoutPercent);

  if (Number.isNaN(metricScoreNumber)) {

    return '0';

  } else {

    const newScoreNumber = getNumericValueBasedOnFilter(metricScoreNumber, filterId);

    return newScoreNumber.toFixed(1);
  }

};
















const getMetricScore = (metricStatistic: WsMetricStatistic, scoreView: WsDecodeScoreView): string => {

  if (scoreView === WsDecodeScoreView.Value) {
    return metricStatistic.convertedValue.toFixed(0); // getMetricValueString(metricStatistic.convertedValue, metricStatistic.baselineValue);

  } else if (scoreView === WsDecodeScoreView.Percent) {
    return getMetricValueStringPercent(metricStatistic.metricValue, metricStatistic.baselineValue);

  } else {
    return getMetricValueString(metricStatistic.metricValue, metricStatistic.baselineValue);
  }
};




const getMetricValueStringPercent = (metricValue: number, baselineValue: number) => {

  if (baselineValue > 0) {

    return `${(metricValue).toFixed(0)}%`;

  } else {
    return `${(metricValue * 10).toFixed(0)}%`;
  }
};




const getMetricValueString = (metricValue: number, baselineValue: number) => {

  if (baselineValue > 0) {

    return `${(metricValue / 10).toFixed(1)}`;

  } else {
    return metricValue.toFixed(1);
  }
};






const getScoreValue = (currentValue: number, baselineValue: number) => {

  // if (currentValue < baselineValue) {

  //   return (currentValue / baselineValue) * 100;

  // } else if (currentValue > baselineValue) {
  //   return 100;
  // } else {
  //   return 100;
  // }

  if (baselineValue > 0) {

    if (baselineValue > currentValue) {

      return (currentValue / baselineValue) * 100;

    } else {
      return 100;
    }

  } else {
    return currentValue;
  }
};














interface WsDecodeCard {
  boardId: number;
}

const getBoardScorePercent = (sourceList: WsDecodeSource[] | undefined, boardList: WsDecodeBoardInterface[], boardId: string) => {
  let scorePercent = 0;

  const boardItem = boardList.find((item) => item.id === Number(boardId));



  // metric based score

  if (sourceList && boardItem) {

    // console.log(`boardItem : ${boardItem.id}`);

    if (boardItem.configuration.metrics && Array.isArray(boardItem.configuration.metrics)) {



      const metricList = boardItem.configuration.metrics as WsDecodeMetric[];



      if (metricList.filter((item) => item.active).length > 0) {



        let metricWeight = 0;

        metricList.forEach((metricItem) => {

          if (metricItem.active) {
            metricWeight += metricItem.weight;
          }
        });



        let metricScore = 0;
        // let metricCount = 0;

        metricList.forEach((metricItem) => {

          if (metricItem.active) {

            const sourceItem = sourceList.find((item) => item.id === metricItem.sourceId);

            const dataValueList = sourceItem ? sourceItem.dataValueList : [];

            const numberValueList = dataValueList.map((value) => dataValueToNumber(value));

            const metricStatistic = getMetricStatistic(sourceList, boardList, metricItem, numberValueList);

            const score = (metricStatistic.metricValue / metricWeight) * metricItem.weight;

            // const metricItemScore = getScoreValue(metricStatistic.metricValue, metricStatistic.baselineValue);

            // metricCount  += 1;

            // metricWeight += metricItem.weight;

            metricScore += score;

          }

        });

        // if (metricWeight > 0) {
        //   scorePercent = metricScore / metricCount;
        // }

        scorePercent = metricScore;



      } else {
       scorePercent = -1; 
      }
    }
  }



  if (scorePercent < 100) {
    return scorePercent;
  } else {
    return 100;
  }
};




const dataValueToNumber = (value: any) => {

  // Handle edge cases
  if (value === null) return 0;
  if (value === undefined) return NaN;
  if (value === "") return 0;

  // Try direct conversion
  const num = Number(value);

  // Check if it's a valid number
  if (!isNaN(num)) return num;

  // Try to extract numeric part if it's a string
  if (typeof value === 'string') {
    // Try to match a number pattern
    const matches = value.match(/^-?\d+(\.\d+)?/);
    if (matches) return Number(matches[0]);
  }

  return 0; // Give up and return NaN
};




const getDataValueListFromDataList = (dataList: WsDecodeData[], dataTable: string, dataField: string) => {

  return dataList
    .filter((item) => item.table === dataTable && item.field === dataField)
    .map((item) => item.value);
    // .sort(() => {
    // });
};





















const randomNonZeroInt = (): number => {
  const magnitude = Math.floor(Math.random() * 10) + 1; // 1 to 10
  const sign = Math.random() < 0.5 ? -1 : 1;
  return magnitude * sign;
};



// Hash a number into a well-distributed 32-bit int
const hash = (seed: number): number => {
  let h = seed | 0;
  h = Math.imul(h ^ (h >>> 16), 2246822507);
  h = Math.imul(h ^ (h >>> 13), 3266489909);
  return (h ^ (h >>> 16)) >>> 0;
};

// Returns a deterministic float in [0, 1) for a given seed (mulberry32-style)
const seededRandom = (seed: number): number => {
  let t = (hash(seed) + 0x6d2b79f5) | 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

const deterministicRandomNonZeroInt = (seed?: number): number => {
  const rand1 = seed === undefined ? Math.random() : seededRandom(seed);
  const rand2 = seed === undefined ? Math.random() : seededRandom(seed + 1);

  const magnitude = Math.floor(rand1 * 10) + 1;
  const sign = rand2 < 0.5 ? -1 : 1;
  return magnitude * sign;
};






const randomInt = (): number => {
  return Math.floor(Math.random() * 10) + 1;
};


const deterministicRandomInt = (seed?: number): number => {
  const rand = seed === undefined ? Math.random() : seededRandom(seed);
  return Math.floor(rand * 10) + 1;
};


const randomIntInRange = (
  min: number,
  max: number,
  seed: number
): number => {
  const rand = seededRandom(seed);
  return Math.floor(rand * (max - min + 1)) + min;
};


const pairSeed = (a: number, b: number): number => ((a + b) * (a + b + 1)) / 2 + b;









// Hash a string into a 32-bit int (FNV-1a)
const hashString = (str: string): number => {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
};

const pairSeedWithString = (a: number, b: number, key: string): number => {
  const cantor = ((a + b) * (a + b + 1)) / 2 + b;
  const strHash = hashString(key);
  // Combine the two with XOR + multiplication to avoid collisions
  return (Math.imul(cantor ^ strHash, 2654435761) >>> 0);
};














export {
  
  randomNonZeroInt,
  deterministicRandomNonZeroInt,

  randomInt,
  deterministicRandomInt,

  randomIntInRange,


  pairSeed,
  pairSeedWithString,



  getBoardScorePercent,
  getScoreValue,
  getMetricStatistic,

  getMetricValueString,
  getMetricValueStringPercent,

  getMetricScore,

  generateDataValueList,
  getConvertedValue,

  dataValueToNumber,
  getDataValueListFromDataList
};




export type {
  WsDecodeCard,
  WsMetricStatistic
};
